var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect2, _path13, _rect3, _path14, _rect4, _path15, _rect5, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSortingGuide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7136 79.9999C47.022 79.577 46.3348 78.2378 46.2026 77.6211H54.5286C54.5286 78.9955 53.0308 79.7797 52.2819 79.9999H48.7136Z",
    fill: "#0B8009"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0028 46.4482C23.897 42.9592 26.8662 42.3513 28.364 42.4835L72.1085 43.1442C75.7084 43.1442 76.8662 44.4494 76.8662 46.8283V75.5231C76.2318 78.8006 73.5182 78.827 72.2406 78.4306C68.5402 77.1618 55.7208 77.9019 49.7737 78.4306C43.853 77.5848 33.0336 78.0781 28.364 78.4306C24.0292 78.4306 24.0027 76.4318 24.0028 74.8623V46.4482Z",
    fill: "#32A637"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6456 43.2844C26.5505 39.7883 29.2226 39.1791 30.5705 39.3116L69.9385 38.6521C73.1783 38.6521 74.2203 41.2816 74.2203 43.6653V72.4189C73.6494 75.7031 71.2072 75.7296 70.0575 75.3323C66.7272 74.061 55.1904 74.8026 49.8383 75.3323C44.5099 74.4847 34.773 74.9792 30.5705 75.3323C26.6694 75.3323 26.6456 73.3294 26.6456 71.7567V43.2844Z",
    fill: "#D8F0D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7709 75.3745C49.4538 75.163 49.6388 75.1101 48.8458 75.1101L49.3745 38.8987H51.8855L51.0925 75.1101C50.696 75.1101 50.4317 75.3745 49.7709 75.3745Z",
    fill: "#96B1D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6079 52.618C33.3833 51.3405 40.1498 49.5519 45.0132 52.618",
    stroke: "#7C9CC4",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6079 59.7547C33.3833 58.4772 40.1498 56.6886 45.0132 59.7547",
    stroke: "#7C9CC4",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6079 67.1556C33.3833 65.8781 40.1498 64.0895 45.0132 67.1556",
    stroke: "#7C9CC4",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3965 52.618C57.1718 51.3405 63.9383 49.5519 68.8018 52.618",
    stroke: "#7C9CC4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3965 59.7547C57.1718 58.4772 63.9383 56.6886 68.8018 59.7547",
    stroke: "#7C9CC4",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3965 67.1556C57.1718 65.8781 63.9383 64.0895 68.8018 67.1556",
    stroke: "#7C9CC4",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2486 52.3764C60.5625 50.7322 66.0264 44.198 66.0264 36.3877C66.0264 27.337 58.6894 20 49.6388 20C40.5881 20 33.2511 27.337 33.2511 36.3877C33.2511 44.2944 38.8507 50.8934 46.3006 52.4351C46.3545 52.8355 46.4808 53.2376 46.6888 53.6262C48.0065 56.0875 51.5354 56.0875 52.853 53.6262C53.0712 53.2187 53.1995 52.7962 53.2486 52.3764Z",
    fill: "#FF5858"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2609 43L39 39H42.9565L42.5217 43H39.2609Z",
    fill: "white",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 37.4783,
    width: 5.82609,
    height: 1.65217,
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2609 43L39 39H42.9565L42.5217 43H39.2609Z",
    fill: "white",
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 37.4783,
    width: 5.82609,
    height: 1.65217,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6087 43L47.3478 39H51.3044L50.8696 43H47.6087Z",
    fill: "white",
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.3478,
    y: 37.4783,
    width: 5.82609,
    height: 1.65217,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9565 43L55.6956 39H59.6522L59.2174 43H55.9565Z",
    fill: "white",
    stroke: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 54.6956,
    y: 37.4783,
    width: 5.82609,
    height: 1.65217,
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2174 27C49.3913 28.087 49.1391 30.3913 46.7391 30.913H45.3478C43.9565 30.7391 41.1652 31.0696 41.1304 33.7826",
    stroke: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4348 32.5217L41.1304 33.7391L42.087 32.5217",
    stroke: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2612 27.4783C49.0872 28.5652 49.3394 30.8696 51.7394 31.3913H53.1307C54.522 31.2174 57.3133 31.5478 57.3481 34.2609",
    stroke: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0438 33L57.3481 34.2174L56.3916 33",
    stroke: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9131 32.1738L49.2174 33.3912L48.2609 32.1738",
    stroke: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1739 28.5652V33.3478",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingGuide);
export default __webpack_public_path__ + "static/media/sorting-guide.68474650dde9f2c2b016f13dd794b246.svg";
export { ForwardRef as ReactComponent };